export default "__VITE_ASSET__be5d5d36__"